
export const createHeadCell = () => {
  const newcol = {
    type: 'th', attrs: {}, children: [{ text: '' }]
  }
  return JSON.parse(JSON.stringify(newcol))
}